export const apiVersion = import.meta.env.VITE_SHOPIFY_API_VERSION
